import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
export class AppErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                hasError: false,
                message: ''
            }
        });
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            message: error.message || 'The app hit an unexpected error.'
        };
    }
    componentDidCatch(error) {
        console.error('AppErrorBoundary caught an error:', error);
    }
    render() {
        if (this.state.hasError) {
            return (_jsx("div", { className: "flex min-h-screen items-center justify-center px-4 py-10", children: _jsxs("div", { className: "glass-panel-strong w-full max-w-2xl rounded-[32px] p-8", children: [_jsx("p", { className: "text-xs font-semibold uppercase tracking-[0.3em] text-rose-500 dark:text-emerald-300", children: "Frontend error" }), _jsx("h1", { className: "mt-3 text-3xl font-semibold text-slate-950 dark:text-slate-50", children: "The screen failed to render." }), _jsx("p", { className: "mt-4 text-sm leading-7 text-slate-700 dark:text-slate-200", children: this.state.message }), _jsx("button", { type: "button", onClick: () => window.location.reload(), className: "mt-6 rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white dark:bg-white dark:text-slate-900", children: "Reload app" })] }) }));
        }
        return this.props.children;
    }
}
